export default "__VITE_ASSET__BC93YO3Q__"